import Portal from 'components/portal'
import { AnimatePresence, motion } from 'framer-motion'
import React from 'react'
import { RootState } from 'store/redux'
import { useDispatch, useSelector } from 'react-redux'
import { toggleSideBar } from 'store/redux/sidebar'
interface SideBarProps {
    children: React.ReactNode
}
const SideBar = ({ children }: SideBarProps) => {
    const dispatch = useDispatch()
    const { isOpen } = useSelector((state: RootState) => state.sideBarControler)
    const onclosesHandler = () => {
        dispatch(toggleSideBar({ isOpen: false }))
    }
    return (
        <>
            <Portal>
                <AnimatePresence>
                    {isOpen && (
                        <div
                            className="fixed mr-[-10px] duration-75 right-0 w-[110%]   top-0 bottom-0 z-[1] flex-col h-screen pr-2 pl-4  gap-4  "
                            onClick={onclosesHandler}
                        >
                            <div className=" relative w-full h-screen flex flex-col  overflow-hidden">
                                <div className=" absolute w-full h-full flex bg-black opacity-50 " />
                                <motion.div
                                    className=" w-fit h-full  bg-white z-[10]	left-[-10px] rounded-l-2xl"
                                    onClick={onclosesHandler}
                                    initial={{ x: '100%' }}
                                    animate={{
                                        x: 0,
                                    }}
                                    exit={{
                                        x: '100%',
                                    }}
                                    transition={{
                                        type: 'spring',
                                        bounce: 0,
                                        duration: 0.4,
                                    }}
                                >
                                    <div className="flex justify-between  items-center h-[5%] px-4">
                                        <button
                                            onClick={onclosesHandler}
                                            className="icon-close text-gray-6 text-[12px]"
                                        />
                                    </div>
                                    <div className="h-[96%] overflow-y-scroll">
                                        {children}
                                    </div>
                                </motion.div>
                            </div>
                        </div>
                    )}
                </AnimatePresence>
            </Portal>
        </>
    )
}

export default SideBar
